module.exports = {
	"articleTitle1": "Classes cancelled after Central power outage, electricity now restored",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "East Hall",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/celebrasia",
	"articleSnippet1": "Nov 2, 2011 ... As of 12:30 p.m. yesterday, most of the eight to 10 buildings had regained power, \nwith the exception of East Hall, which did not have electricity ...",
	"articleSnippet2": "Nov 15, 2015 ... Flowdom, a student dance organization, performs at Celebrasia in the East Hall \nAtrium on Saturday. Celebrasia was hosted by the Chinese ...",
	"totalMisc": 0,
	"articleTitle2": "Student groups 'Celebrasia' with food, performances ",
	"address": "530 Church St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.275721,
		"lng": -83.735192
	},
	"tips": [
		{
			"text": "Both of the atriums are really great for meeting with groups and doing some work, but be advised that outlets aren't plentiful",
			"person": "Nick Kortman"
		}
	],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/easthall.json
// module id = 869
// module chunks = 0